import { GetAgentVoicesQuery, GetCurrentSubscriptionInfoQuery, GetUserAgentsQuery } from 'graphql/generated';

export type IAgent = GetUserAgentsQuery['getUserAgents']['agents'][0];

export type IAgentVoices = NonNullable<GetAgentVoicesQuery['getAgentVoices']['voices']>;

export type ICurrentSubscription = GetCurrentSubscriptionInfoQuery['getCurrentSubscriptionInfo']['subscription'];

/**
 * Enum representing the various states of a user's subscription.
 */
export enum ISubscriptionStatus {
    /** Subscription was created, but the first payment failed. */
    incomplete = 'incomplete',
    /** Subscription was not successfully activated, and the payment window expired. */
    incomplete_expired = 'incomplete_expired',
    /** Subscription is in a trial period. */
    trialing = 'trialing',
    /** Subscription is active and automatically renews. */
    active = 'active',
    /** Subscription is active, but the last payment failed. */
    past_due = 'past_due',
    /** Subscription was canceled and will not renew. */
    canceled = 'canceled',
    /** Subscription remains active, but payment attempts failed. */
    unpaid = 'unpaid',
    /** Subscription is temporarily paused (unofficial status). */
    paused = 'paused',
}

export enum CallServiceType {
    VOCODE = 'Vocode',
    VAPI = 'Vapi',
}

export enum PhoneStatusType {
    draft = 'draft',
    pending_review = 'pending-review',
    in_review = 'in-review',
    twilio_rejected = 'twilio-rejected',
    twilio_approved = 'twilio-approved',
    buy_number = 'buy-number',
    demo_number = 'demo-number',
}
